// Third party
import {
  AccountsListRandomDocument,
  AccountsListRandomQuery,
  AccountsListRandomQueryVariables,
} from '@gql';

// Utils
import { createApolloClient } from '../apollo-node-client';
import { notEmpty } from '../not-empty';

export const imperativeNodeRandomAccountsQuery = async () => {
  const apolloClient = createApolloClient();

  const options: AccountsListRandomQueryVariables = {
    pageSize: 30,
  };

  const result = await apolloClient.query<AccountsListRandomQuery>({
    query: AccountsListRandomDocument,
    variables: options,
  });

  const footerAccounts = result.data.accountsListRandom.entries
    .map((account) => {
      return account;
    })
    .filter(notEmpty);

  return footerAccounts;
};

export type FooterAccountPartial =
  AccountsListRandomQuery['accountsListRandom']['entries'][0];
